import { OpenUrlDocumentAccept } from '@/domain/usecases/accept-digital'
import { RemoteOpenUrlDocAccept } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'

export const makeOpenUrlDocAcceptFactory = (): OpenUrlDocumentAccept => {
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteOpenUrlDocAccept(httpClient)
}
